import $ from 'jquery';
import setHeight from '../../scripts/util/dom/setHeight';
import checkKey from '../../scripts/util/event/checkKey';
import {brandSubscribe} from '../api/api';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-brand-card',
			dom: {
				filter: '.js-brand-card-filter',
				tablet: '.js-brand-card-filter-tablet',
				toggle: '.js-brand-toggle',
				content: '.js-brand-content',
				wrapper: '.js-brand-wrapper',
				subscribe: '.js-brand-subscribe'
			},
			classes: {
				brand: {
					state: {
						open: 'brand-card_state_open'
					}
				},
				more: {
					open: 'brand-card__more_state_open'
				},
				subscribe: {
					success: 'brand-card__link_state_success',
					underline: {
						dashed: 'link_underline_dashed',
						none: 'link_underline_none'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$filter = $(this.options.dom.filter);
		this.$tablet = $(this.options.dom.tablet);
		this.$toggle = $(this.options.dom.toggle);
		this.$more = $(this.options.dom.content);
		this.$wrapper = $(this.options.dom.wrapper);
		this.$subscribe = this.$el.find(this.options.dom.subscribe);
		this.$document = $(document);
		this.$window = $(window);
		this.open = this.options.classes.brand.state.open;
	}

	onClick(e) {
		const $target = $(e.target);
		const $el = $target.closest(this.$el);
		$el.toggleClass(this.open);
	}

	onResize() {
		const isActive = $(`.${this.options.classes.more.open}`);
		if (isActive.length) {
			setHeight(this.$more, this.$wrapper);
		}
	}

	onSubscribeSuccess = link => () => {
		const classes = this.options.classes.subscribe;
		link.removeClass(classes.underline.dashed);
		link.addClass(classes.success);
		link.addClass(classes.underline.none);
		link.text('Подписка добавлена');
		setTimeout(() => {
			link.removeClass(classes.underline.none);
			link.text('Перейти в подписки');
			link.unbind('click');
		}, 3000);
	}

	onSubscribe = e => {
		e.preventDefault();
		const $target = $(e.target);
		const data = {test: 'test'}; // TODO: change to real data
		brandSubscribe(data).then(
			this.onSubscribeSuccess($target),
			() => console.log('error')
		);
	}

	toggleMore() {
		const state = this.$more.data('state');
		if (state === 'close') {
			this.moreOpen();
		} else {
			this.moreClose();
		}
	}

	moreOpen() {
		setHeight(this.$more, this.$wrapper);
		this.$more.addClass(this.options.classes.more.open);
		this.$more.css('overflow', 'hidden');
		this.$more.data('state', 'open');
		this.$toggle.text('Свернуть информацию');
	}

	moreClose() {
		this.$more.css('height', 0);
		this.$more.removeClass(this.options.classes.more.open);
		this.$more.data('state', 'close');
		this.$toggle.text('Подробнее о бренде');
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$filter.on('click', this.onClick.bind(this));
			this.$toggle.on('click', () => this.toggleMore());
			this.$window.on('resize', () => this.onResize());
			this.$document.on('keydown', e => {
				if (checkKey(e)) {
					this.moreClose();
				}
			});
			this.$subscribe.on('click', this.onSubscribe);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/brand-card/brand-card.js
 **/